/* ============================================================
   LUXURY ANIMATIONS — Lesly Curlz
   Motion-driven premium experience
   ============================================================ */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile  = window.innerWidth <= 768 || ('ontouchstart' in window);
  var M       = null; // Motion library ref (set after load)

  /* ── Utility: get Motion safely ─────────────────────────── */
  function getM() {
    return window.Motion || null;
  }

  /* ── Run fn after Motion module resolves ────────────────── */
  function withMotion(fn) {
    if (window.Motion) { fn(window.Motion); return; }
    var attempts = 0;
    var t = setInterval(function () {
      if (window.Motion || attempts++ > 40) {
        clearInterval(t);
        if (window.Motion) fn(window.Motion);
      }
    }, 50);
  }

  /* ============================================================
     1. PAGE LOADER
     ============================================================ */
  function initLoader() {
    var loader = document.getElementById('lc-loader');
    if (!loader) return;

    function hideLoader() {
      loader.classList.add('lc-done');
      /* Keep in DOM — reused by initAccountBtn() on account navigation */
    }

    function hideVeilAndLoader() {
      hideLoader();
      var veil = document.getElementById('lc-page-veil');
      if (veil) veil.classList.remove('lc-veil-enter');
    }

    if (document.readyState === 'complete') {
      setTimeout(hideLoader, 1600);
    } else {
      window.addEventListener('load', function () {
        setTimeout(hideLoader, 900);
      });
    }

    /* Bouton retour / avant : bfcache restore */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) hideVeilAndLoader();
    });

    /* Navigation history (popstate) */
    window.addEventListener('popstate', hideVeilAndLoader);
  }

  /* ============================================================
     2. CUSTOM CURSOR
     ============================================================ */
  function initCursor() {
    if (mobile || window.matchMedia('(pointer: coarse)').matches) return;

    var dot   = document.getElementById('lc-cursor');
    var trail = document.getElementById('lc-cursor-trail');
    if (!dot || !trail) return;

    var mx = 0, my = 0, tx = 0, ty = 0;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top  = my + 'px';
    });

    (function loop() {
      tx += (mx - tx) * 0.11;
      ty += (my - ty) * 0.11;
      trail.style.left = tx + 'px';
      trail.style.top  = ty + 'px';
      requestAnimationFrame(loop);
    })();

    /* Hover expand */
    document.querySelectorAll('a, button, [role=button], .badge, .product-visual')
      .forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          dot.classList.add('lc-hover');
          trail.classList.add('lc-hover');
        });
        el.addEventListener('mouseleave', function () {
          dot.classList.remove('lc-hover');
          trail.classList.remove('lc-hover');
        });
      });
  }

  /* ============================================================
     3. SCROLL PROGRESS INDICATOR
     ============================================================ */
  function initScrollBar() {
    var bar = document.getElementById('lc-scroll-bar');
    if (!bar) return;

    function update() {
      var s = window.scrollY;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--lc-scroll', h > 0 ? (s / h) : 0);
    }
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ============================================================
     4. NAVBAR GLASSMORPHISM
     ============================================================ */
  function initNavbar() {
    var nav = document.getElementById('navbar');
    if (!nav) return;

    function update() {
      nav.classList.toggle('lc-glass', window.scrollY > 55);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ============================================================
     5. CANVAS PARTICLES (hero)
     ============================================================ */
  function initParticles() {
    if (reduced) return;

    var canvas = document.getElementById('lc-particles-canvas');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var P   = [];
    var COLORS = [
      'rgba(107,63,160,',
      'rgba(167,139,250,',
      'rgba(212,175,55,',
      'rgba(249,168,212,',
      'rgba(139,92,246,'
    ];

    function resize() {
      canvas.width  = canvas.parentElement.offsetWidth;
      canvas.height = canvas.parentElement.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    var N = mobile ? 18 : 40;
    for (var i = 0; i < N; i++) {
      P.push({
        x:  Math.random() * canvas.width,
        y:  Math.random() * canvas.height,
        r:  Math.random() * 2.5 + .8,
        dx: (Math.random() - .5) * .35,
        dy: (Math.random() - .5) * .35 - .15,
        c:  COLORS[i % COLORS.length],
        a:  Math.random() * .4 + .15,
        ph: Math.random() * Math.PI * 2
      });
    }

    function tick() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var t = Date.now() / 1000;

      P.forEach(function (p) {
        p.x += p.dx; p.y += p.dy;
        if (p.x < -5)              p.x = canvas.width  + 5;
        if (p.x > canvas.width+5)  p.x = -5;
        if (p.y < -5)              p.y = canvas.height + 5;
        if (p.y > canvas.height+5) p.y = -5;

        var pulse = Math.sin(t * 1.4 + p.ph) * .25 + .75;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * pulse, 0, Math.PI * 2);
        ctx.fillStyle = p.c + (p.a * pulse) + ')';
        ctx.fill();
      });
      requestAnimationFrame(tick);
    }
    tick();
  }

  /* ============================================================
     6. KINETIC TYPOGRAPHY (hero title)
     — walks DOM text nodes only; never touches HTML tags or entities
     ============================================================ */
  function initKineticTitle() {
    if (reduced) return;

    var title = document.querySelector('.hero-title');
    if (!title) return;

    var delay = 0;

    function walkText(node) {
      if (node.nodeType === 3 /* TEXT_NODE */) {
        var text = node.textContent;
        if (!text.replace(/\s/g, '').length) return; // whitespace-only
        var frag = document.createDocumentFragment();
        for (var i = 0; i < text.length; i++) {
          var ch = text[i];
          if (/\s/.test(ch)) {
            frag.appendChild(document.createTextNode(ch));
          } else {
            var span = document.createElement('span');
            span.className = 'lc-ch';
            span.style.animationDelay = delay.toFixed(2) + 's';
            span.textContent = ch;
            frag.appendChild(span);
            delay += 0.038;
          }
        }
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1 /* ELEMENT_NODE */) {
        /* Clone the live NodeList to avoid mutation issues */
        Array.prototype.slice.call(node.childNodes).forEach(walkText);
      }
    }

    title.classList.add('lc-split');
    walkText(title);
  }

  /* ============================================================
     7. SCROLL REVEAL (generic)
     ============================================================ */
  function initReveal() {
    var targets = document.querySelectorAll(
      '.animate-on-scroll, .animate-left, .animate-right, .animate-scale'
    );
    if (!targets.length) return;

    if (reduced) return; /* already visible by default in CSS */

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.remove('lc-init');
          e.target.classList.add('lc-vis');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: .1, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      /* Only hide elements that start off-screen */
      if (rect.top > window.innerHeight) {
        el.classList.add('lc-init');
      } else {
        el.classList.add('lc-vis');
      }
      obs.observe(el);
    });
  }

  /* ============================================================
     8. REVIEW CARDS — staggered entrance
     ============================================================ */
  function initReviews() {
    var cards = document.querySelectorAll('.review-card');
    if (!cards.length) return;

    if (reduced) return; /* already visible by default in CSS */

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.remove('lc-init-card');
          e.target.classList.add('lc-vis');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: .12 });

    cards.forEach(function (c, i) {
      var rect = c.getBoundingClientRect();
      if (rect.top > window.innerHeight) {
        c.classList.add('lc-init-card');
        c.style.transitionDelay = (i * 0.09) + 's';
      } else {
        c.classList.add('lc-vis');
      }
      obs.observe(c);
    });
  }

  /* ============================================================
     9. STARS LIGHTING UP ON SCROLL
     ============================================================ */
  function initStars() {
    if (reduced) return;

    document.querySelectorAll('[data-lc-stars]').forEach(function (el) {
      var stars = el.querySelectorAll('.lc-star');
      if (!stars.length) return;

      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          stars.forEach(function (s, i) {
            setTimeout(function () { s.classList.add('lc-lit'); }, i * 110 + 100);
          });
          obs.unobserve(e.target);
        });
      }, { threshold: .5 }).observe(el);
    });
  }

  /* ============================================================
     10. BADGE SEQUENTIAL BOUNCE
     ============================================================ */
  function initBadges() {
    if (reduced) return;

    document.querySelectorAll('[data-lc-badge-group]').forEach(function (group) {
      var badges = group.querySelectorAll('.badge[data-lc-badge]');
      if (!badges.length) return;

      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          badges.forEach(function (b, i) {
            setTimeout(function () { b.classList.add('lc-vis'); }, i * 110);
          });
          obs.unobserve(e.target);
        });
      }, { threshold: .3 }).observe(group);
    });
  }

  /* ============================================================
     11. GOLDEN RIPPLE ON BUTTONS
     ============================================================ */
  function initRipple() {
    document.querySelectorAll('.btn-primary, .btn-secondary, .btn-cart')
      .forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var r   = btn.getBoundingClientRect();
          var rip = document.createElement('span');
          var sz  = Math.max(r.width, r.height);
          rip.className = 'lc-ripple';
          rip.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;'
            + 'left:' + (e.clientX - r.left - sz / 2) + 'px;'
            + 'top:'  + (e.clientY - r.top  - sz / 2) + 'px;';
          btn.appendChild(rip);
          rip.addEventListener('animationend', function () { rip.remove(); });
        });
      });
  }

  /* ============================================================
     12. PRODUCT JAR FLOAT (CSS class)
     ============================================================ */
  function initProductJar() {
    var img = document.querySelector('.product-visual .product-visual__img');
    if (img) img.classList.add('lc-product-float');
  }

  /* ============================================================
     13. PARALLAX on data-lc-parallax elements
     ============================================================ */
  function initParallax() {
    if (mobile || reduced) return;

    var els = document.querySelectorAll('[data-lc-parallax]');
    if (!els.length) return;

    window.addEventListener('scroll', function () {
      var sy = window.scrollY;
      els.forEach(function (el) {
        var speed = parseFloat(el.dataset.lcParallax) || 0.25;
        var rect  = el.getBoundingClientRect();
        var cy    = rect.top + rect.height / 2 + sy;
        el.style.transform = 'translateY(' + ((sy - cy) * speed) + 'px)';
      });
    }, { passive: true });
  }

  /* ============================================================
     14. ACCOUNT NAVIGATION LOADER
     — Réaffiche le loader LC avant la redirection vers la page compte Shopify
     ============================================================ */
  function initAccountBtn() {
    var loader = document.getElementById('lc-loader');
    if (!loader) return;

    var btns = document.querySelectorAll('#accountBtn, .mobile-menu__account');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var dest = btn.href;
        if (!dest) return;

        e.preventDefault();
        e.stopImmediatePropagation(); /* empêche le handler veil de initPageTransitions() */

        /* Relance l'animation de la barre de chargement */
        var fill = loader.querySelector('.lc-loader__bar-fill');
        if (fill) {
          fill.style.animation = 'none';
          fill.offsetHeight; /* force reflow pour redémarrer l'animation CSS */
          fill.style.animation = '';
        }

        /* Affiche le loader */
        loader.classList.remove('lc-done');

        /* Redirige après 750ms (barre de chargement à ~70%) */
        setTimeout(function () { window.location.href = dest; }, 750);
      });
    });
  }

  /* ============================================================
     15. PAGE TRANSITIONS
     ============================================================ */
  function initPageTransitions() {
    if (reduced) return;

    var veil = document.getElementById('lc-page-veil');
    if (!veil) return;

    /* Leave animation on arrival */
    veil.classList.add('lc-veil-leave');
    setTimeout(function () { veil.classList.remove('lc-veil-leave'); }, 500);

    document.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href[0] === '#' || href.indexOf('mailto') === 0
          || href.indexOf('tel') === 0 || href.indexOf('javascript') === 0
          || link.target === '_blank') return;

      link.addEventListener('click', function (e) {
        var dest = link.href;
        if (!dest || dest === window.location.href) return;

        e.preventDefault();
        veil.classList.add('lc-veil-enter');
        setTimeout(function () { window.location.href = dest; }, 550);
      });
    });
  }

  /* ============================================================
     15. MOTION.JS — choreographed effects
     ============================================================ */
  function initMotion(M) {
    if (reduced || !M || !M.animate) return;

    /* Hero jar — let jarFloat3D CSS animation handle it (scale(2) must be preserved) */

    /* Product jar */
    var pJar = document.querySelector('.product-visual .product-visual__img');
    if (pJar) {
      pJar.classList.remove('lc-product-float');
      try {
        M.animate(pJar,
          { y: [0, -14, 0], rotate: [-0.4, 0.4, -0.4] },
          { duration: 5, repeat: Infinity, easing: 'ease-in-out' }
        );
      } catch (e) { pJar.classList.add('lc-product-float'); }
    }

    /* Review cards — Motion inView with spring */
    if (M.inView) {
      try {
        document.querySelectorAll('.review-card').forEach(function (card, i) {
          M.inView(card, function () {
            M.animate(card,
              { opacity: [0, 1], y: [40, 0], scale: [.96, 1] },
              {
                duration: 0.65,
                delay: i * 0.09,
                easing: [0.34, 1.56, 0.64, 1]
              }
            );
          }, { amount: 0.15 });
        });
      } catch (e) { /* CSS fallback already in place */ }
    }
  }

  /* ============================================================
     INIT — DOMContentLoaded
     ============================================================ */
  function boot() {
    initLoader();
    initCursor();
    initScrollBar();
    initNavbar();
    initParticles();
    /* initKineticTitle() disabled — race condition with data-i18n-html replacement */
    initReveal();
    initReviews();
    initStars();
    initBadges();
    initRipple();
    initProductJar();
    initParallax();
    initAccountBtn();    /* doit être avant initPageTransitions() pour stopImmediatePropagation */
    initPageTransitions();

    /* Motion enhancements — wait for ESM module */
    withMotion(initMotion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
